import LcChopCivicLikerRect from "./LcChopCivicLikerRect";

export { LcChopCivicLikerRect };
export default LcChopCivicLikerRect;
